export default __webpack_public_path__ + "static/blob5-8062f31804636521d5820740c8d73ab6.svg";